<template>
    <v-spa-submenu-container
        class="relative h-full"
        container="absolute z-[100] shadow-lg bg-white whitespace-nowrap rounded"
        position="right-0"
        ref="submenu"
        @hidden="$emit('change')"
    >
        <template v-slot:default="slotProps">
            <div
                @click.prevent.stop="$refs.submenu.show()"
                class="h-full cursor-pointer"
                :class="task.due_date ? 'text-sm' : 'text-xs text-gray-400 hover:text-gray-600'"
            >
                <slot>
                    <task-due-date :task="task" :empty-text="$t('trustup-io-task.no_due_date')" />
                </slot>
            </div>
        </template>
        <template v-slot:submenu>
            <date-picker
                class="!border-0"
                v-model="task.due_date_date"
                :is-inline="true"
                :locale="$i18n.locale"
                :attributes="[
                    {
                        key: 'today',
                        dot: true,
                        dates: new Date(),
                    },
                ]"
                :step="1"
                @input="task.setDueDateFromDate()"
            />
        </template>
    </v-spa-submenu-container>
</template>

<script>
    import DatePicker from 'v-calendar/lib/components/date-picker.umd';
    import TaskDueDate from './DueDate.vue';

    export default {
        components: {
            DatePicker,
            TaskDueDate
        },
        props: {
            task: {
                type: Object,
                required: true
            }
        }
    }
</script>